import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

export function initOnboarding(): void {
  const showedOnboardings = storage.onboarding.get();

  Entities.onboarding.setShowedOnboardings(showedOnboardings);
}
